import script from "./FormSave.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSave.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__